export default __webpack_public_path__ + "static/media/twitter-icon.d1762ab4.svg";